import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const DISMISS_KEY = 'demoBannerDismissed';

// Bandeau affiché sur tout le site (sous le header), invitant à essayer une démonstration avant
// achat. Le message suit la page : exemple de mini-site sur les pages mini-sites de mariage,
// exemple de carte sur les fiches de cartes à gratter, les deux ailleurs (accueil, FAQ, panier…).
// Fermeture mémorisée pour la session du navigateur uniquement (sessionStorage).
const DEMOS = {
  carte: { to: '/exemple-carte-a-gratter', label: 'carte à gratter' },
  minisite: { to: '/exemple-faire-part-anime', label: 'faire-part animé' },
};

const demosFor = (pathname) => {
  // Pages des faire-part et invitations animés : page chapeau, pages d'occasion, fiches (leur adresse
  // contient toujours « -anime »).
  if (/-anime(e|s)?(-|$)/.test(pathname)) return [DEMOS.minisite];
  if (pathname.startsWith('/produit/') || pathname === '/cartes-a-gratter-personnalisees') return [DEMOS.carte];
  return [DEMOS.carte, DEMOS.minisite];
};

const linkSx = { color: '#fff', fontWeight: 600, textDecoration: 'underline', textUnderlineOffset: 3 };
const DemoBanner = () => {
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  // Pas de bandeau sur la démo elle-même, ni sur la carte ou le mini-site d'un client (il a déjà
  // acheté : pas besoin de lui proposer un exemple).
  const hideOn = ['/exemple-carte-a-gratter', '/exemple-faire-part-anime'];
  const isCardPage = location.pathname.startsWith('/carte-a-gratter/')
    || location.pathname.startsWith('/carte-surprise/')
    || location.pathname.startsWith('/voir-ma-carte/')
    || location.pathname.startsWith('/personnaliser-mini-site/');
  if (dismissed || hideOn.includes(location.pathname) || isCardPage) return null;

  const demos = demosFor(location.pathname);

  const handleClose = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // localStorage/sessionStorage indisponible (navigation privée…) : on masque quand même pour cette session React
    }
  };

  return (
    <Box
      sx={{
        bgcolor: '#8C8BC4',
        color: '#fff',
        textAlign: 'center',
        py: 1,
        px: 5,
        position: 'relative',
        fontSize: { xs: '0.8rem', md: '0.9rem' },
      }}
    >
      <Typography component="span" sx={{ fontWeight: 600, fontSize: 'inherit' }}>
        {demos.length === 1 ? (
          <>✨ Envie de voir un exemple de {demos[0].label} ? <Box component={Link} to={demos[0].to} sx={linkSx}>Cliquez ici</Box></>
        ) : (
          <>
            ✨ Envie de voir un exemple ?{' '}
            <Box component={Link} to={demos[0].to} sx={linkSx}>Carte à gratter</Box>
            {' · '}
            <Box component={Link} to={demos[1].to} sx={linkSx}>Faire-part animé</Box>
          </>
        )}
      </Typography>
      <IconButton
        aria-label="Fermer"
        onClick={handleClose}
        size="small"
        sx={{ position: 'absolute', top: '50%', right: 6, transform: 'translateY(-50%)', color: '#fff' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default DemoBanner;
